import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { retry } from 'rxjs/operators';

const LOGGING_ENDPOINT = 'api/log/error';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private http: HttpClient) { }

  logError(error: Error) {
    const errorMessage = {
      message: error.message,
      stack: error.stack
    };

    return this.http.post(LOGGING_ENDPOINT, errorMessage).pipe(
      retry(1)
    );
  }
}
